export interface FaqItem {
  question: string;
  answer: string;
}

export interface FaqTab {
  key: string;
  label: string;
  items: FaqItem[];
}

export const faqTabs: FaqTab[] = [
  {
    key: 'randevu',
    label: 'Randevu',
    items: [
      {
        question: 'Neden randevu almalıyım?',
        answer:
          'Ön görüşme, ihtiyacınızı anlatmanız ve hangi görüşme ya da destek seçeneğinin uygun olabileceğini netleştirmeniz için yapılır. Böylece sorularınız belirli bir görüşme süresi içinde daha düzenli biçimde ele alınabilir.',
      },
      {
        question: 'Hangi randevuyu seçmeliyim?',
        answer:
          'Randevu sayfasındaki görüşme başlıklarını ve açıklamalarını inceleyerek ihtiyacınıza en yakın seçeneği seçebilirsiniz. Emin değilseniz “Göç Rehberliği Ön Görüşmesi” için talep oluşturabilir veya WhatsApp üzerinden bize ulaşabilirsiniz.',
      },
      {
        question: 'Randevu talebini nasıl oluşturabilirim?',
        answer:
          'Randevu sayfasında istediğiniz görüşmenin altındaki “Randevu Talep Et” butonuna tıklayın. Seçtiğiniz görüşmenin adı WhatsApp mesajına otomatik olarak eklenir. Mesajı göndererek talebinizi iletebilirsiniz.',
      },
      {
        question: 'Randevum nasıl kesinleşir?',
        answer:
          'Talebiniz WhatsApp üzerinden değerlendirildikten sonra uygun gün ve saat karşılıklı olarak belirlenir. Gün ve saat onaylandığında randevunuz kesinleşir.',
      },
      {
        question: 'Görüşmeye nasıl katılırım?',
        answer:
          'Görüşmeler online yapılır. Randevunuz kesinleştikten sonra görüşmeye katılmanız için gerekli bağlantı ve bilgiler sizinle paylaşılır.',
      },
    ],
  },
  {
    key: 'goc-rehberligi',
    label: 'Göç Rehberliği',
    items: [
      {
        question: 'Neden Ayşegül Saraç?',
        answer:
          "Ayşegül Saraç, 2020 yılında ailesiyle birlikte İstanbul'dan Köln'e taşınırken edindiği deneyimleri Göç Notları blogunda ve YouTube kanalında paylaşmaktadır. Almanya'ya taşınmayı planlayan birey ve ailelere, kendi deneyimlerine ve araştırmalarına dayalı genel bilgiler ile organizasyonel hazırlık desteği sunmaktadır.",
      },
      {
        question: 'Neden Göç Süreçleri Rehberliği almalıyım?',
        answer:
          "Almanya'ya taşınırken karşılaşabileceğiniz hazırlık ve yerleşim adımlarını daha planlı ilerletmek için organizasyonel destek alabilirsiniz. Görüşmelerde ihtiyaçlarınız dinlenir ve sunulabilecek destek seçenekleri açıklanır.",
      },
      {
        question: 'Göç Süreçleri Rehberliği ücretleri hakkında nasıl bilgi alabilirim?',
        answer:
          'Ön görüşmelerin süre ve ücret bilgileri Randevu sayfasında yer almaktadır. Ön görüşme sonrasında farklı bir destek hizmetine ihtiyaç duyulursa kapsam ve ücret bilgisi ayrıca paylaşılır.',
      },
      {
        question: "Göç Süreçleri Rehberliği Almanya'nın tüm eyaletleri için geçerli mi?",
        answer:
          "Online görüşmelere Almanya'nın bütün şehir ve eyaletlerinden katılabilirsiniz. Ancak idari uygulamalar eyalet, şehir ve kişisel duruma göre farklılık gösterebilir.",
      },
      {
        question: "Almanya'ya göç sürecinde hangi hizmetleri sunuyorsunuz?",
        answer:
          'Taşınma öncesi hazırlık, eğitim, vize ve oturum süreçlerine ilişkin genel bilgiler, ev kiralama ve göç sonrası yerleşim konularında deneyime dayalı bilgi ve organizasyonel hazırlık desteği sunuyoruz. Güncel hizmet alanlarını Hizmetler sayfasında inceleyebilirsiniz.',
      },
      {
        question: 'Hukuki süreçler için destek alabiliyor muyum?',
        answer:
          'Sunulan hizmetler genel bilgilendirme, deneyim paylaşımı ve organizasyonel hazırlık desteğiyle sınırlıdır. Somut duruma ilişkin hukuki değerlendirme, hukuk danışmanlığı ve resmi makamlar önünde temsil gerektiren işlemler hukuk ortağımız Avukat Dr. Hayrullah Özcan tarafından yürütülür.',
      },
    ],
  },
];

export const faqItems = faqTabs.reduce<FaqItem[]>((items, tab) => items.concat(tab.items), []);
